import { render } from "./SelGroup.vue?vue&type=template&id=bbdc157e"
import script from "./SelGroup.vue?vue&type=script&lang=js"
export * from "./SelGroup.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__